import { useCallback } from 'react';

import qs from 'qs';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import type { NormalizedFormValues } from '#src/app/pages/petitionDetails/shared/types';
import { useQueryParamValue } from '#src/app/shared/hooks/location';

type Options = Readonly<{ guest: 'new' | 'existing' }>;

export function useGenerateGuestRedirectUrl(): (data: NormalizedFormValues, { guest }: Options) => string {
	const {
		data: { petition: details },
	} = usePetitionDetailsPageData();
	const recruiter = useQueryParamValue('recruiter');

	return useCallback(
		(data: NormalizedFormValues, { guest }: Options) => {
			const query = {
				guest,
				short_display_name: data.firstName,
				...(recruiter ? { recruiter } : {}),
				source_location: 'petition_page',
			};
			return `/p/${details.slug}/psf/promote_or_share?${qs.stringify(query, { encodeValuesOnly: true })}`;
		},
		[details, recruiter],
	);
}
